import { memo } from 'react'
import { LinearGradient } from './LinearGradient'
import Styles from './ProfileImage.module.scss'
import { Image } from './Image'
import { getInitials } from 'utils'

interface Props {
  profileImageUrl: string | null
  alt: string
  userId: number
}

const ProfileImage = ({ profileImageUrl, alt, userId }: Props) => {
  const label = getInitials(alt)
  return profileImageUrl?.length ? (
    <Image alt={label} src={profileImageUrl} size={120} />
  ) : (
    <LinearGradient userId={userId} darken={15}>
      <span className={Styles.initials}>{label}</span>
    </LinearGradient>
  )
}

const MemoizedProfileImage = memo(ProfileImage)

export { MemoizedProfileImage as ProfileImage }
